import {JobFarmInstanceState} from "@generated"
import {StateLabel} from "@platform/models/state-labels/state-label"

export const JobFarmInstanceStateLabels: Map<JobFarmInstanceState, StateLabel<JobFarmInstanceState>> = new Map<
    JobFarmInstanceState,
    StateLabel<JobFarmInstanceState>
>([
    [JobFarmInstanceState.Running, {state: JobFarmInstanceState.Running, label: "Running"}],
    [JobFarmInstanceState.Stopped, {state: JobFarmInstanceState.Stopped, label: "Stopped"}],
    [JobFarmInstanceState.Paused, {state: JobFarmInstanceState.Paused, label: "Paused"}],
    [JobFarmInstanceState.NotResponding, {state: JobFarmInstanceState.NotResponding, label: "Not Responding"}],
    [JobFarmInstanceState.Updating, {state: JobFarmInstanceState.Updating, label: "Updating"}],
])
